<template>
  <div class="basic-block block-menu-base" :style="styles">
    <div class="content-wrap">
      <transition name="tablist">
        <div class="selected-list">
          <div class="list-item"
                v-for="(lItem, lIdx) in selectedList"
                :key="`${lIdx}_${lItem.url_id}`"
                @click="onListItemClick(lItem.url, lItem.gaLabel)"
          >
            <span class="item-title">{{lItem.title}}</span>
            <span v-if="!!lItem.price" class="item-price">￥{{lItem.price}}（税込）<span class="encourage-subscr" v-if="+lItem.yearluck_flg > 0">月額会員は¥0</span></span>
            <span class="item-arrow"><img src="/static/img/recommend/lp/common/icon_menu_arrow.svg" alt=""></span>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BlockMenuItem',
  components: {
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    gaEventCateg: {
      type: String,
      default: '',
    },
    selectedList: {
      type: Array,
      default(){
        return []
      }
    },
    baseCol: {
      type: String,
      default: '#6799CB',
    },
    itemFontCol: {
      type: String,
      default: '#9C8961',
    },
    frameCol: {
      type: String,
      default: '#9C8961',
    },
  },
  data() {
    return {
    }
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--tm-base-col': this.baseCol,
        '--tm-item-font': this.itemFontCol,
        '--tm-frame-col': this.frameCol,
      }
    },
  },
  methods: {
    onListItemClick(url, gaLabel){
      console.log(url)
      window.gtag('event', 'click', {
        'event_category': this.gaEventCateg,
        'event_label': gaLabel ? gaLabel : '',
      })
      location.href = this.$handoverParams(url)
    },
  },
}</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";

$l_col_tm_base_col: var(--tm-base-col);
$l_col_tm_item_font: var(--tm-item-font);
$l_col_tm_frame_col: var(--tm-frame-col);

.block-menu-base {
  position: relative;

  .content-wrap {
    overflow: hidden;
  }
  .selected-list {
    $col_list_base: $l_col_tm_frame_col;
    border: 1px solid $col_list_base;
    padding: 8px 20px;
    border-radius: 10px;
    background: white;
    .list-item {
      color: $l_col_tm_item_font;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      border-bottom: 1px solid #dadada;
      padding: 16px 38px 16px 0;
      // min-height: 100px;
      cursor: pointer;
      user-select: none;
      &:last-child {
        border: none;
      }
      .item-title {
        display: inline-block;
        font-size: 14px;
        font-weight: bold;
        line-height: 20px;
      }
      .item-price {
        color: #ff7497;
        display: inline-block;
        font-size: 12px;
        font-weight: bold;
        .encourage-subscr {
          color: #6CD7D0;
        }
      }
      .item-arrow {
        width: 28px;
        height: 28px;
        border-radius: 28px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-left: 2px;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        background: $l_col_tm_base_col;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/blocks/BlockMenusItem.vue